import fetch from '../utils/fetch';
import store from '@/vuex/index';
import CONFIG from '../config/index';

// 支付服务 https://apidoc.syounggroup.com/doc.html#/支付服务/Alipay/tradeCreateUsingPOST

/**
 * 支付宝小程序预支付接口（支付宝统一首单交易创建接口）
 *
 * @export
 * @param {*} tenantTradeNo 租户订单号
 * @param {*} tradeAmount 订单金额
 * @param {*} bizType 业务类型,如普通订单-NORMAL，积分商城订单-CREDIT_MALL
 * @param {*} [commodityInfos=[]] 订单中的商品信息
 * @param {string} orderType 订单类型， NORMAL - 普通，GLOBAL - 跨境
 * @returns
 */
export async function alipayTradeCreate(
  tenantTradeNo,
  tradeAmount,
  bizType,
  commodityInfos = [],
  orderType,
  isComponent,
  sourceId = '',
  period,
  izPCreditInstallment,
  activityConsultId,
  receiverInfo
) {
  let buyerId = store.state.alipayUserId;
  // let buyerId = ''
  // 如果出现获取本地userId  uni.getStorageSync('userId') 失败时再去请求接口获取userId
  if (!buyerId) {
    let result = '';
    try {
      result = await store.dispatch('getPesonalCenterInfo');
    } catch (err) {
      // 接口失败的话，再调用一次
      await store.dispatch('getPesonalCenterInfo').then(res => {
        result = res;
      });
    }
    buyerId = result && result.data && result.data.alipayVO && result.data.alipayVO.userid;
  }
  const postData = {
    bizType: bizType,
    buyerId, // TODO 支付宝用户ID
    tenantId: CONFIG.TENANT_ID,
    subject: store.state.shopInfo.name || '水羊潮妆商城',
    tenantTradeNo,
    tradeAmount,
    commodityInfos,
    izPCreditInstallment,
  };
  if (izPCreditInstallment === '1') {
    // 如果开启花呗分期则传入分期数
    postData.period = period;
  }
  if (orderType === 'GLOBAL') postData.subject = '跨境-' + postData.subject;
  if (!CONFIG.IS_PROD) postData.subject = 'T' + postData.subject;
  const other = {
    header: {
      'X-Biz-Code': 'SHOP',
    },
  };
  if (isComponent) {
    // 如果是走交易组件订单
    if (activityConsultId) {
      // 如果有前置优惠组件传回的优惠咨询ID
      postData.activityConsultId = activityConsultId;
    }
    if (receiverInfo) {
      postData.receiverInfo = receiverInfo;
    }
    return fetch.post(
      '/pay/api/alipay/miniComponentTradeCreate',
      {
        ...postData,
        sourceId,
      },
      other
    );
  }
  return fetch.post('/pay/api/alipay/tradeCreate', postData, other);
}

// /pay/api/weChatPay/mina
// zhangyu:因需支付微信代金券，微信所有的预支付接口都需要带上商品信息，以下接口都有修改，麻烦两位小伙伴这个版本改一下

/**
 *
 *
 * @export 微信预支付接口
 * @param {*} tenantTradeNo 交易订单号
 * @param {*} tradeAmount 交易金额
 * @param {*} bizType 交易类型
 * @param {*} [commodityInfos=[]] 商品信息
 * @param {*} type 是否跨境 GLOBAL
 * @returns {appid: 公众号或小程序id, codeUrl: 微信返回的二维码url, mwebUrl: 支付跳转链接, nonceStr: 随机串, partnerId: 商户id, paySign: 签名, prepayId: 预支付ID, signType: 签名方式, timeStamp: 时间戳, wxPackage: 数据包}
 */
export function weChatPayMina(tenantTradeNo, tradeAmount, bizType, commodityInfos = [], type) {
  const { openId } = store.state;
  const postData = {
    buyerId: openId,
    tenantId: CONFIG.TENANT_ID,
    bizType: bizType,
    body: type === 'GLOBAL' ? '跨境-水羊潮妆商城' : '水羊潮妆商城',
    tenantTradeNo,
    tradeAmount,
    commodityInfos,
  };
  if (!CONFIG.IS_PROD) postData.body = 'T' + postData.body;
  const other = {
    header: {
      'X-Biz-Code': 'SHOP',
    },
  };
  return fetch.post('/pay/api/weChatPay/mina', postData, other);
}

/**
 * 微信jsApi支付（微信内）
 * tenantTradeNo (string): 租户订单号 ,
 * tradeAmount (number): 交易金额 ,
 * bizType (string): 业务类型,如普通订单-NORMAL，兑换商城订单-CREDIT_MALL ,
 * body (string): 商品描述 ,
 * @param {{tenantTradeNo: string, tradeAmount: number, bizType: string, buyerId: string, body: string}} postData
 */
export function weChatPayJsApi(postData) {
  const { openId } = store.state;
  postData.buyerId = openId;
  postData.tenantId = 'soyoung';
  postData.wapName = '水羊潮妆商城';

  postData.wapUrl = location.origin;

  postData.body = '水羊潮妆商城';
  if (postData.orderType === 'GLOBAL') postData.body = '跨境-' + postData.body;
  if (!CONFIG.IS_PROD) postData.body = 'T' + postData.body;
  const headers = {};

  headers['X-Biz-Code'] = 'GZHSHOP';




  return fetch.post('/pay/api/weChatPay/jsApi', postData, {
    headers,
  });
}

export function accountListPaymentChannel() {
  return fetch.get(
    '/pay/api/account/listPaymentChannel',
    {},
    {
      header: {
        'X-Biz-Code': 'GZHSHOP',
      },
    }
  );
}
/**
 * 支付宝支付
 * tenantTradeNo (string): 租户订单号
 * tradeAmount (number): 交易金额
 * bizType (string): 业务类型,如普通订单-NORMAL，兑换商城订单-CREDIT_MALL ,
 * buyerId (string, optional): 支付宝的用户ID，非必传 ,
 * returnUrl (string, optional): 页面跳转同步通知页面路径 ,
 * @param {{tradeAmount: number, orderType: string, bizType: string, commodityInfos: *, tenantTradeNo: string, returnUrl: string}} postData
 */
export function alipayMWeb(postData) {
  postData.subject = '水羊潮妆商城';
  if (postData.orderType === 'GLOBAL') postData.subject = '跨境-' + postData.subject;
  if (!CONFIG.IS_PROD) postData.subject = 'T' + postData.subject;
  return fetch.post('/pay/api/alipay/mWeb', postData, {
    headers: {
      'X-Biz-Code': 'GZHSHOP',
    },
  });
}

/**
 * 微信H5支付（微信外）
 * tenantTradeNo (string): 租户订单号 ,
 * tradeAmount (number): 交易金额 ,
 * bizType (string): 业务类型,如普通订单-NORMAL，积分商城订单-CREDIT_MALL ,
 * buyerId (string): ，
 * body (string): 商品描述 ,
 * @param {{tenantTradeNo: string, tradeAmount: number, bizType: string, buyerId: string, body: string}} postData
 */
export function weChatPayMWebPay(postData) {
  postData.tenantId = 'soyoung';
  postData.wapName = '水羊潮妆商城';
  postData.body = '水羊潮妆商城';
  if (postData.orderType === 'GLOBAL') postData.body = '跨境-' + postData.body;

  postData.wapUrl = location.origin;

  return fetch.post('/pay/api/weChatPay/mWeb', postData, {
    headers: {

      'X-Biz-Code': 'GZHSHOP',

    },
  });
}

// 获取支付宝花呗分期配置
export function calculateCreditInstallment(data) {
  return fetch.post('/newretail/api/orderPrice/calculateCreditInstallment', data);
}
